import tuijianImg from '../assets/tuijian.png';
import { List, Row, Col } from 'antd';
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import unit from '../unit';

// 新增：路径参数与数字的映射关系
const typeMap = {
  'institution': 1,
  'niusan': 2,
  'fund': 3,
  'nationalteam': 4,
  'foreigncapital': 5
};

// 推荐列表
const RecommendSideBar = (props) => {
  const navigate = useNavigate();
  const [name, setName] = useState('机构');
  const [dataSource, setDataSource] = useState([]);

  const getSourceList = (type) => {
    // 将路径参数转换为数字类型
    const numericType = typeMap[type] || type;
    
    const path = '/pc/gudong/getRecommend';
    unit.httpGet(path, { "type": numericType }, (data) => {
      setName(data.name);
      if (data.list && data.list.data && data.list.data.length > 0) {
        let _dataSource = [];
        for (let i = 0; i < data.list.data.length; i++) {
          let tmp = {};
          tmp['index'] = i + 1;
          tmp['code'] = data.list.data[i].param.param.code;
          tmp['name'] = data.list.data[i].name;
          tmp['stock_num'] = data.list.data[i].stock_num;
          tmp['stock_value'] = unit.bigNumberTransform(data.list.data[i].stock_value).replace(/(\d+\.\d+)千亿/, (match, p1) => {
            return (parseFloat(p1) * 1000).toFixed(0) + '亿';
          });
          _dataSource.push(tmp);
        }
        setDataSource(_dataSource);
      }
    });
  };

  useEffect(() => {
    const type = props.type;
    getSourceList(type);
  }, [props.type]); // 监听 props.type 的变化

  // 修改：使用映射后的路径参数值进行判断
  if (props.type === 'fund' || props.type === 'foreigncapital') {
    return null;
  }

  return (
    <div className='content-block'>
      <div className='block-title' style={{ background: "linear-gradient( 180deg, #D5E2FF 0%, #FFFFFF 100%)" }}>
        <img className='title-icon' src={tuijianImg} /> <span style={{ verticalAlign: 'middle' }}>{name}推荐</span>
      </div>
      <List
        itemLayout="horizontal"
        size="small"
        split={false}
        locale={{ emptyText: "暂无数据" }}
        dataSource={dataSource}
        renderItem={(item, index) => (
          <List.Item>
            <Link to={`/detail/${item.code}`}>
              <List.Item.Meta
                title={
                  <div>
                    <span className={unit.getTextClassName(index)}>{index + 1}</span>
                    <span>{item.name}</span>
                  </div>
                }
                description={
                  <Row>
                    <Col span={10} style={{ marginLeft: '15px' }}>持股：{item.stock_num}</Col>
                    <Col span={10}>持仓市值：{item.stock_value}</Col>
                  </Row>
                }
              />
            </Link>
          </List.Item>
        )}
      />
    </div>
  );
};

export default RecommendSideBar;